// extracted by mini-css-extract-plugin
export default {"accepted":"EvaluationStatus_accepted__IPVIm","declined":"EvaluationStatus_declined__0-Zur"};